export const colors = {
  brand: {
    primary: "#005924", // Updated to deep green for a strong, professional look
    primaryDark: "#004015", // Darker shade of the primary for depth and sophistication
    textPrimary: "#1A1A1A", // Nearly black for strong readability
    textDark: "#0D0D0D", // Deep black for headers and important text
    textGrey: "#7A7A7A", // Medium gray for secondary text and less critical information
    bgLight: "#E4E7EB", // Off white for a clean, open background
  },
  gray: {
    100: "#F0F0F0",
    200: "#D4D4D4",
    300: "#A9A9A9",
    400: "#7D7D7D",
    500: "#616161",
    600: "#454545",
  },
  active: {
    100: "#B8E986", // Light green, keeping as is for variety
    800: "#005924", // Updated to deep green for call to action
  },
  pending: {
    100: "#FFF3CD", // Warm light yellow for 'awaiting action' or 'notice'
    800: "#FFC107", // Bold yellow for highlights and warnings
  },
  rejected: {
    100: "#FADBD8", // Soft red for errors or 'rejected' states in light mode
    800: "#E74C3C", // A clear red for immediate attention
  },
  inActive: {
    100: "#E8E8E8", // Light gray for disabled or inactive elements
    800: "#A6A6A6", // Darker gray for secondary inactive information
  },
  danger: {
    800: "#C0392B", // Strong red for critical alerts or actions
  },
  success: {
    100: "#A9DFBF", // Soft green for success messages or indicators
    800: "#005924", // Updated to deep green for success states
  },
  white: {
    text: "#E4E7EB",
  },
}
